import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {EPDSFile} from "../../../models/file-upload";
import {UtilService} from "../../../services/util.service";
import {FileUploadService} from "../../../services/file-upload.service";
import {catchError, finalize, tap, throwError} from "rxjs";
import {ProtestInfoService} from "../../../services/protest-info.service";
import {FileUploadComponent} from "../../file-upload/file-upload.component";

@Component({
    selector: 'app-add-agency-rep',
    templateUrl: './add-agency-rep.component.html',
    styleUrls: ['./add-agency-rep.component.scss'],
    standalone: false
})
export class AddAgencyRepComponent {
  @ViewChild('fileUpload', { static: false }) fileUpload!: FileUploadComponent;
  @Input() a_No = '';

  @Output() onSubmit = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  comments?: string;

  fileUploadInProgress = false;
  uploadDocMessage = this.fileUploadService.udmPdfExcel;
  requiredFileType = this.fileUploadService.rftPdfExcel;
  attachAssociatedDocOutput = false;
  primaryFiles: EPDSFile[] = [];

  constructor(public util: UtilService,
              private readonly fileUploadService: FileUploadService,
              private readonly protestInfoService: ProtestInfoService) {
  }

  onFormCancel() {
    this.fileUploadInProgress = false;
    this.onCancel.emit();
  }

  onEPDSFileListChange(epdsFileList: EPDSFile[], typeOfList: string): void {
    console.debug("EPDS File list for type %s: %O", typeOfList, epdsFileList);

    if (typeOfList === 'P') {
      this.primaryFiles = epdsFileList;
    }

    console.debug(this.primaryFiles);
  }

  onFormSubmit() {
    const allFiles = [
      ...this.primaryFiles.map(epdsFile => ( { epdsFile, attachmentType: 'noticeOfAppearance' })),
    ];

    console.debug(allFiles);

    this.fileUploadInProgress = true;
    this.fileUploadService.submitFile(allFiles, this.a_No, this.fileUpload)
      .pipe(finalize(() => this.fileUploadInProgress = false))
      .pipe(tap(resp => console.log('Response from submitFile:', resp)),
      catchError(err => {
        // console.error('Error in submitFile:', err);
        return throwError(err);
      })
    ).subscribe(resp => {
      console.debug(resp);

      const reqeustType = 'agency-rep-request';
      const typeOfDocument = 'Notice Of Appearance';
      const docId = 0;
      const isDocConfidential = 'N';
      if (this.comments)
        this.comments = this.util.removeCurlyQuotes(this.comments);

      this.protestInfoService.addAgencyRep(this.a_No, this.comments!, reqeustType, typeOfDocument, docId, isDocConfidential).subscribe((agencyRepResp) => {
        console.log(agencyRepResp);
        if (agencyRepResp.inputErrors) {
          let message = "";
          agencyRepResp.inputErrors.forEach(inputErrors =>  message += inputErrors.invalidValue + ": " + inputErrors.message + '<br>');
          this.util.displayDialogMessage("Input Errors", message);
        } else {
          if (agencyRepResp.submitNewDocDTO) {
            this.util.displayDialogMessage('Success', 'You have successfully submitted a request to join a case.').subscribe(() => {
              this.onSubmit.emit();
            });
          } else {
            this.util.displayDialogMessage('Error', 'There was a problem joining the case.');
          }
        }
      });
    });
  }

}
